import {
  IApiSuccessWrapper,
  IExportStatus,
  ITableObject,
  QRARowEntryCRID
} from '$/types'
import { apiSlice } from 'app/services/api'
import {
  convertRiskUnitToAPIRiskValueParameter,
  ILocalFilter,
  RiskUnitType
} from 'features/RiskManagement/Components/LocalFilter'

const SYSTEM_SCOPE_ID_PARAM_NAME = 'systemScopeId'

export interface IGetQRATableQueryParams {
  systemScopeId: string
  localFilter: ILocalFilter
  riskUnit: RiskUnitType
  // Categories such as 'Threat'
  tableTypeSelections: (string | null)[]
  lineViewMode?: 'Input' | 'Output'
  savedStateId1?: string
  savedStateId2?: string
  assessmentId?: string
  continuousRouteId?: string
}

export const qraDataTableApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getQRATable: build.query<
      ITableObject<QRARowEntryCRID>,
      IGetQRATableQueryParams
    >({
      query: ({
        systemScopeId,
        localFilter,
        riskUnit,
        tableTypeSelections,
        lineViewMode,
        savedStateId1,
        savedStateId2,
        assessmentId,
        continuousRouteId
      }) => ({
        method: 'POST',
        url: '/qra/datatable',
        params: {
          [SYSTEM_SCOPE_ID_PARAM_NAME]: systemScopeId,
          savedStateId1,
          savedStateId2,
          assessmentId,
          continuousRouteId
        },
        body: {
          localFilter,
          riskValue: convertRiskUnitToAPIRiskValueParameter(riskUnit),
          tableType: tableTypeSelections,
          lineViewTableType: lineViewMode
        }
      }),
      transformResponse: (
        res: IApiSuccessWrapper<ITableObject<QRARowEntryCRID>>
      ) => {
        return res.result
      }
    }),
    addQRATableExportJob: build.mutation<
      IExportStatus,
      IGetQRATableQueryParams
    >({
      query: ({
        systemScopeId,
        localFilter,
        riskUnit,
        tableTypeSelections,
        lineViewMode,
        savedStateId1,
        savedStateId2,
        assessmentId,
        continuousRouteId
      }) => ({
        url: '/qra/datatable/export',
        method: 'POST',
        params: {
          [SYSTEM_SCOPE_ID_PARAM_NAME]: systemScopeId,
          savedStateId1,
          savedStateId2,
          assessmentId,
          continuousRouteId
        },
        body: {
          localFilter,
          riskValue: convertRiskUnitToAPIRiskValueParameter(riskUnit),
          tableType: tableTypeSelections,
          lineViewTableType: lineViewMode
        }
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IExportStatus
      }
    })
  })
})

export const { useGetQRATableQuery, useAddQRATableExportJobMutation } =
  qraDataTableApi
